import { postTaggingEligibility } from '../api/spm';
export default async (logger) => {
    return await postTaggingEligibility({}, logger);
};
